import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    // debug: true,
    resources: {
      'en-US': {
        translation: {
          'submit': 'Sign Up',
          'email-placeholder': 'Enter your email address',
          'signup-success': 'You\'re now signed up to this subscription',
          'already-signed-up': 'You\'re already signed up to this subscription',
          'sign-up-error': 'Sorry, we\'re having trouble signing you up right now. Please try again later',
        },
      },
      'en-GB': {
        translation: {
          'submit': 'Sign Up'
        }
      },

    },
  });

export default i18n;